import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';

@Pipe({
  name: 'resourceUrl',
})
export class DocumentResourceUrlPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(url: string): SafeResourceUrl | null {
    if (!environment.allowedIFrameDomains.some((domain) => url.startsWith(domain))) {
      throw new Error(
        'url is not part of allowed domains - ' +
          JSON.stringify({ url, allowedIFrameDomains: environment.allowedIFrameDomains }),
      );
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
